import React from "react";

export default function CloudInfraImg(props) {
  const theme = props.theme;
  return (
    <svg
      id="cloud-infra-illustration"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 900 620"
    >
      <title>Cloud Data Infrastructure</title>
      <ellipse
        cx="450"
        cy="590"
        rx="320"
        ry="22"
        fill={theme.compImgHighlight}
      />

      {/* Main cloud body */}
      <g fill={theme.imageHighlight}>
        <ellipse cx="450" cy="200" rx="160" ry="70" opacity="0.95" />
        <circle cx="360" cy="175" r="58" opacity="0.95" />
        <circle cx="430" cy="155" r="72" opacity="0.95" />
        <circle cx="520" cy="170" r="62" opacity="0.95" />
        <circle cx="560" cy="200" r="48" opacity="0.95" />
      </g>
      {/* Soft cloud highlight */}
      <ellipse
        cx="420"
        cy="165"
        rx="48"
        ry="22"
        fill="#fff"
        opacity="0.22"
      />

      {/* AWS-style service nodes hanging from cloud */}
      <g stroke={theme.accentColor} strokeWidth="2.5" fill="none" opacity="0.8">
        <line x1="320" y1="250" x2="280" y2="310" />
        <line x1="400" y1="265" x2="380" y2="320" />
        <line x1="500" y1="265" x2="520" y2="320" />
        <line x1="580" y1="250" x2="620" y2="310" />
      </g>

      {/* Lambda / function chip */}
      <g transform="translate(240 300)">
        <rect
          width="80"
          height="56"
          rx="10"
          fill={theme.compImgHighlight}
          stroke={theme.imageHighlight}
          strokeWidth="2"
        />
        <text
          x="40"
          y="34"
          textAnchor="middle"
          fontFamily="Segoe UI, Helvetica, Arial, sans-serif"
          fontSize="18"
          fontWeight="700"
          fill={theme.accentColor}
        >
          λ
        </text>
      </g>

      {/* ECS / container node */}
      <g transform="translate(340 310)">
        <rect
          width="80"
          height="56"
          rx="10"
          fill={theme.compImgHighlight}
          stroke={theme.imageHighlight}
          strokeWidth="2"
        />
        <rect
          x="16"
          y="14"
          width="48"
          height="28"
          rx="4"
          fill={theme.imageHighlight}
          opacity="0.85"
        />
        <rect x="22" y="20" width="12" height="8" rx="1" fill="#fff" opacity="0.7" />
        <rect x="38" y="20" width="12" height="8" rx="1" fill="#fff" opacity="0.7" />
        <rect x="22" y="32" width="12" height="8" rx="1" fill="#fff" opacity="0.7" />
        <rect x="38" y="32" width="12" height="8" rx="1" fill="#fff" opacity="0.7" />
      </g>

      {/* API Gateway / mesh node */}
      <g transform="translate(480 310)">
        <rect
          width="80"
          height="56"
          rx="10"
          fill={theme.compImgHighlight}
          stroke={theme.imageHighlight}
          strokeWidth="2"
        />
        <path
          d="M20 28 H60 M40 14 V42"
          stroke={theme.accentColor}
          strokeWidth="3"
          strokeLinecap="round"
        />
        <circle cx="20" cy="28" r="4" fill={theme.accentColor} />
        <circle cx="60" cy="28" r="4" fill={theme.accentColor} />
        <circle cx="40" cy="14" r="4" fill={theme.accentColor} />
        <circle cx="40" cy="42" r="4" fill={theme.accentColor} />
      </g>

      {/* S3 / storage node */}
      <g transform="translate(580 300)">
        <rect
          width="80"
          height="56"
          rx="10"
          fill={theme.compImgHighlight}
          stroke={theme.imageHighlight}
          strokeWidth="2"
        />
        <ellipse cx="40" cy="18" rx="22" ry="7" fill={theme.imageHighlight} />
        <path
          d="M18 18 V38 C18 44 62 44 62 38 V18"
          fill="none"
          stroke={theme.imageHighlight}
          strokeWidth="3"
        />
        <ellipse cx="40" cy="28" rx="22" ry="7" fill="none" stroke={theme.imageHighlight} strokeWidth="2" />
      </g>

      {/* Kubernetes hex cluster (left) */}
      <g transform="translate(70 160)">
        <polygon
          points="70,10 120,40 120,100 70,130 20,100 20,40"
          fill={theme.compImgHighlight}
          stroke={theme.accentColor}
          strokeWidth="3"
        />
        <polygon
          points="70,40 95,55 95,85 70,100 45,85 45,55"
          fill={theme.imageHighlight}
          opacity="0.9"
        />
        <circle cx="70" cy="70" r="8" fill="#fff" />
        {/* Pods */}
        <circle cx="55" cy="58" r="4" fill={theme.accentColor} />
        <circle cx="85" cy="58" r="4" fill={theme.accentColor} />
        <circle cx="55" cy="82" r="4" fill={theme.accentColor} />
        <circle cx="85" cy="82" r="4" fill={theme.accentColor} />
      </g>

      {/* Docker whale-ish container stack (right) */}
      <g transform="translate(720 155)">
        <rect
          x="10"
          y="50"
          width="100"
          height="70"
          rx="12"
          fill={theme.compImgHighlight}
          stroke={theme.imageHighlight}
          strokeWidth="2"
        />
        <rect x="28" y="30" width="28" height="20" rx="3" fill={theme.imageHighlight} />
        <rect x="62" y="30" width="28" height="20" rx="3" fill={theme.imageHighlight} />
        <rect x="28" y="68" width="64" height="12" rx="2" fill={theme.imageHighlight} opacity="0.7" />
        <rect x="28" y="88" width="44" height="12" rx="2" fill={theme.accentColor} opacity="0.85" />
        {/* Waves */}
        <path
          d="M5 130 Q25 118 45 130 T85 130 T125 130"
          fill="none"
          stroke={theme.imageHighlight}
          strokeWidth="3"
          opacity="0.6"
        />
      </g>

      {/* Streaming pipeline (Kafka / Kinesis) */}
      <g transform="translate(180 420)">
        <rect
          width="540"
          height="70"
          rx="14"
          fill={theme.compImgHighlight}
        />
        {/* Flow arrows */}
        <g fill={theme.imageHighlight}>
          <rect x="24" y="22" width="70" height="26" rx="6" opacity="0.9" />
          <polygon points="104,22 124,35 104,48" />
          <rect x="134" y="22" width="70" height="26" rx="6" opacity="0.75" />
          <polygon points="214,22 234,35 214,48" />
          <rect x="244" y="22" width="70" height="26" rx="6" opacity="0.9" />
          <polygon points="324,22 344,35 324,48" />
          <rect x="354" y="22" width="70" height="26" rx="6" opacity="0.75" />
          <polygon points="434,22 454,35 434,48" />
          <rect x="464" y="22" width="52" height="26" rx="6" fill={theme.accentColor} />
        </g>
        <text
          x="270"
          y="64"
          textAnchor="middle"
          fontFamily="Segoe UI, Helvetica, Arial, sans-serif"
          fontSize="11"
          fill={theme.text}
          opacity="0.7"
        >
          Kafka · Kinesis · ETL
        </text>
      </g>

      {/* Data stores: Postgres + Redis + Vector */}
      <g transform="translate(300 500)">
        {/* Postgres cylinder */}
        <ellipse cx="40" cy="12" rx="28" ry="9" fill={theme.imageHighlight} />
        <path
          d="M12 12 V40 C12 48 68 48 68 40 V12"
          fill={theme.compImgHighlight}
          stroke={theme.imageHighlight}
          strokeWidth="2"
        />
        <ellipse cx="40" cy="40" rx="28" ry="9" fill={theme.imageHighlight} opacity="0.85" />

        {/* Redis cache box */}
        <rect
          x="100"
          y="8"
          width="56"
          height="40"
          rx="8"
          fill={theme.accentColor}
        />
        <rect
          x="112"
          y="18"
          width="32"
          height="6"
          rx="2"
          fill="#fff"
          opacity="0.85"
        />
        <rect
          x="112"
          y="30"
          width="22"
          height="6"
          rx="2"
          fill="#fff"
          opacity="0.55"
        />

        {/* Vector DB dots */}
        <g fill={theme.imageHighlight}>
          <circle cx="200" cy="16" r="6" />
          <circle cx="222" cy="28" r="6" />
          <circle cx="200" cy="40" r="6" />
          <circle cx="244" cy="16" r="5" opacity="0.7" />
          <circle cx="244" cy="40" r="5" opacity="0.7" />
        </g>
        <g stroke={theme.accentColor} strokeWidth="1.5" fill="none" opacity="0.8">
          <line x1="200" y1="16" x2="222" y2="28" />
          <line x1="222" y1="28" x2="200" y2="40" />
          <line x1="222" y1="28" x2="244" y2="16" />
          <line x1="222" y1="28" x2="244" y2="40" />
        </g>
      </g>

      {/* Terraform / IaC badge */}
      <g transform="translate(760 400)">
        <rect
          width="70"
          height="70"
          rx="14"
          fill={theme.imageDark || theme.compImgHighlight}
          stroke={theme.accentColor}
          strokeWidth="2"
        />
        <path
          d="M18 22 h16 v16 H18z M38 22 h16 v16 H38z M18 42 h16 v16 H18z"
          fill="#7B42BC"
        />
        <path d="M38 42 h16 v16 H38z" fill="#5C4EE5" opacity="0.9" />
      </g>
    </svg>
  );
}
